export default [
  { id: 'dietType', label: 'Diet Type' },
  { id: 'exerciseLevel', label: 'Exercise Level' },
  { id: 'smoking', label: 'Smoking', type: 'boolean' },
];